module.exports = __webpack_public_path__ + "static/media/hands.bd9592dc.png";